/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UserProfileData { 
    userNo?: string;
    userName?: string;
    userChineseName?: string;
    telephone?: string;
    telephoneExtension?: string;
    cellPhone?: string;
    email?: string;
    gender?: boolean;
    enable?: boolean;
    salaryCompanyId?: number;
    hireDate?: Date;
    quitDate?: Date;
    trialDate?: Date;
    updateUserNo?: string;
    updateTime?: Date;
}